<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-confirm-container">
          <div class="modal-confirm-header">
            <div>
              <div class="d-flex flex-row pt-3 pe-3 pb-0">
                <span class="ms-auto me-0 right" @click="$emit('closeModal')"
                  ><i
                    class="fa fa-times"
                    style="font-size: x-large !important"
                  ></i
                ></span>
              </div>
            </div>
          </div>
          <div>
            <section>
              <div id="title-modal" class="mx-3">
                {{ t("CL_CONTRACT.MODAL_TITLE") }}
              </div>
              <p class="text-black mt-3 mx-3">
                {{
                  t("CL_CONTRACT.MODAL_DESCRIPTION", {
                    borrowed,
                    totalToPay,
                  })
                }}
              </p>
            </section>
            <section id="offer-explainer-footer" class="container">
              <div class="row">
                <div class="col-8 text-start text-black fw-bold">
                  {{ t("CL_CONTRACT.TABLE_LEGEND_1") }}
                </div>
                <div class="col-4 text-end fw-bold text-black">
                  ${{ borrowed }}
                </div>
              </div>
              <div class="row">
                <div class="col-8 text-start">
                  {{ t("CL_CONTRACT.TABLE_LEGEND_2") }}
                </div>
                <div class="col-4 text-end">
                  ${{ interestTotal.toFixed(2) }}
                </div>
              </div>
              <div class="row">
                <div class="col-8 text-start">
                  {{ t("CL_CONTRACT.TABLE_LEGEND_3") }}
                </div>
                <div class="col-4 text-end">
                  ${{ minimumPayment.toFixed(2) }}
                </div>
              </div>
              <div class="row">
                <div class="col-8 text-start">
                  {{ t("CL_CONTRACT.TABLE_LEGEND_4") }}
                </div>
                <div class="col-4 text-end">{{ t("CL_CONTRACT.DAYS") }}</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  name: "InterestExplainerModal",
  props: {
    show: Boolean,
    borrowed: Number,
    interestTotal: Number,
    minimumPayment: Number,
  },
  computed: {
    totalToPay() {
      return (Number(this.borrowed) + Number(this.interestTotal)).toFixed(2);
    },
  },
  emits: ["closeModal"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  margin-top: 2%;
}

.modal-confirm-container {
  margin: 0 auto;
  width: 90%;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.modal-confirm-header {
  color: black;
}

.modal-confirm-body {
  font-style: normal;
  left: 0;
  right: 0;
  color: #000;
}

.modal-confirm-header > span:hover {
  cursor: pointer;
}

.modal-confirm-footer {
  display: flex;
  justify-content: space-around;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-confirm-container,
.modal-leave-to .modal-confirm-container {
  transform: translateY(-20px);
  opacity: 0;
}

.modal-button {
  border-radius: 8px;
}

.btn-success {
  margin-top: 15px;
  color: white;
  background-color: $pj-color-green;
  border-color: $pj-color-green;
  width: 161px;
  height: 48px;
}

.btn-success:hover {
  background-color: $pj-color-gray;
  border-color: $pj-color-gray;
}

.btn-outline-success {
  margin-top: 17px;
  color: $pj-color-green;
  border-color: $pj-color-green;
  width: 131px;
  height: 44px;
}

.btn-outline-success:hover {
  color: white;
  background-color: $pj-color-gray;
  border-color: $pj-color-gray;
}

.btn-success:focus,
.btn-outline-success:focus {
  box-shadow: none;
}

.offer-summary {
  display: flex;
  flex-direction: column;
  background: $pj-color-green-hover;
  padding: 10px;
  border-radius: 16px;
}

#offer-explainer-footer {
  border-radius: 0 0 1rem 1rem;
  background: #f8fbf5;
  left: 0;
  right: 0;

  & .container {
    & .row {
      margin-top: 0.5rem;
      color: #666;
      font-family: Inter;
      font-size: 0.9375rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.4375rem;
      letter-spacing: 0.01875rem;
    }
  }
}

#offer-explainer-footer > div:nth-child(n) {
  margin-top: 0.5rem;
  color: #666;
}
#title-modal {
  color: black;
  font-size: 18px;
  font-family: Nunito;
  font-weight: 700;
  line-height: 33px;
  word-wrap: break-word;
}
</style>
